// The location's money format as the backend sends it (Location#currency_format, TD1-10207):
// the Rails I18n `number.currency.format` slice that `number_to_currency` itself reads.
//   unit      display symbol -- "$", "CAD", "€". NOT an ISO 4217 code.
//   format    where the symbol goes -- "%u%n" ($1,234.50) or "%n %u" (1.234,50 €).
//   precision decimal places.
//   delimiter thousands mark -- "," or "." or " ".
//   separator decimal mark -- "." or ",".
//
// Used when the location has not loaded yet, or is served by a backend that predates the field.
// USD because that is the currency TapGoods itself bills in.
export const US_CURRENCY_FORMAT = {
  unit: '$',
  format: '%u%n',
  precision: 2,
  delimiter: ',',
  separator: '.',
};

export const countryToLocale = {
  USA: 'en-US',
  CAN: 'en-CA',
};
